import React, { useEffect } from 'react';
import InputField from '../../../components/CustomFields/InputField';
import { academyLogger } from "utils/logger";

const AddressListDetails = ({ student = {}, handleNestedChange }) => {

    useEffect(() => {
        // Log the applicant data to check if contactPersonList exists
        academyLogger.info('Address list', student.addressList);
    }, [student]);

    // Example state options for the dropdown. You can modify this based on your requirements.
    const stateOptions = {
        India: ["Tamil Nadu", "Andhra Pradesh", "Bihar", "Delhi", "Goa", "Gujarat"],
        USA: ["California", "Texas", "New York", "Florida", "Washington"],
        Canada: ["Ontario", "Quebec", "British Columbia", "Alberta"],
        Mexico: ["Chihuahua", "Jalisco", "Puebla", "Veracruz"],
        Other: ["Other"]
    };

    return (
        <section>
            <h2 className="text-lg font-semibold text-[#824296] text-center">Address Details</h2>
            {student.addressList.map((address, index) => (
                <div key={index} className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {/* Street Name 1 */}
                    <InputField
                        id={`streetName1-${index}`}
                        label="Street Name 1 *"
                        value={address.streetName1}
                        onChange={(e) =>
                            handleNestedChange("addressList", index, "streetName1", e.target.value)
                        }
                    //placeholder="Enter Street Name 1"
                    />

                    {/* Street Name 2 */}
                    <InputField
                        id={`streetName2-${index}`}
                        label="Street Name 2"
                        value={address.streetName2}
                        onChange={(e) =>
                            handleNestedChange("addressList", index, "streetName2", e.target.value)
                        }
                    //placeholder="Enter Street Name 2"
                    />



                    {/* Country */}
                    <InputField
                        id={`country-${index}`}
                        label="Country *"
                        value={address.country}
                        onChange={(e) => handleNestedChange("addressList", index, "country", e.target.value)}
                        options={["India", "USA", "Canada", "Mexico", "Other"]}
                        defaultOption="Select Country"
                    />

                    {/* State - Dropdown */}
                    <InputField
                        id={`state-${index}`}
                        label="State *"
                        value={address.state}
                        onChange={(e) => handleNestedChange("addressList", index, "state", e.target.value)}
                        options={stateOptions[address.country] || []}
                        defaultOption="Select State"
                    />

                    {/* City */}
                    <InputField
                        id={`city-${index}`}
                        label="City *"
                        value={address.city}
                        onChange={(e) => handleNestedChange("addressList", index, "city", e.target.value)}
                    //placeholder="Enter City"
                    />

                    {/* Zipcode */}
                   {/* Zipcode or Pincode */}
<InputField
    id={`zipcode-${index}`}
    label={
        address.country === "USA"
            ? "Zipcode *"
            : address.country === "India"
            ? "Pincode *"
            : "Postal Code *"
    }
    value={address.zipcode}
    onChange={(e) =>
        handleNestedChange("addressList", index, "zipcode", e.target.value)
    }
/>



                </div>
            ))}
        </section>
    );
};

export default AddressListDetails;
